import { FC, HTMLProps } from "react";
import { UseControllerReturn } from "react-hook-form";
import { FormGroup } from "modules/SubmitPage/components/FormGroup";
import cx from "classnames";

type TextInputProps = {
  label?: string;
  groupClassName?: string;
  hint?: string;
};

export const TextInput: FC<
  TextInputProps &
    UseControllerReturn<any, any> &
    HTMLProps<HTMLInputElement> &
    HTMLProps<HTMLTextAreaElement>
> = ({
  label,
  field,
  fieldState,
  groupClassName,
  hint,
  type = "text",
  className,
  as: Component = "input",
  formState,
  ...props
}) => {
  return (
    <FormGroup
      label={label}
      error={fieldState?.error?.message}
      className={groupClassName}
      hint={hint}
    >
      <Component
        {...props}
        {...field}
        // @ts-ignore
        type={type}
        className={cx(
          "input input-bordered w-full",
          {
            "input-error": !!fieldState?.error?.message,
          },
          className
        )}
      />
    </FormGroup>
  );
};
